// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3mMni","actions":"GroupTable_actions__15v2O","deleteModalFooter":"GroupTable_deleteModalFooter__3_CSS"};